<template>
  <basic-container>
    <avue-crud
      v-if="avueCrudVisible"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
      :upload-preview="uploadPreview"
      :upload-before="uploadBefore"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.regulationsystem_delete"
          @click="handleDelete"
          >删 除
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-s-order"
          v-if="permission.regulationsystem_edit"
          @click="openSystemTypeDialog"
          >制度类型管理
        </el-button>
      </template>
    </avue-crud>
    <!--    制度类型管理弹窗-->
    <openSystemType ref="openSystemType" @closeWindow="getDialogData"></openSystemType>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getTreeChildrenPowerNode,
} from '@/api/v4ward/clientserve/regulationsystem';
import { mapGetters } from 'vuex';
import openSystemType from './systemtype';
export default {
  components: {
    openSystemType,
  },
  data() {
    return {
      avueCrudVisible: false,
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        indexLabel: '序号',
        columnBtn: false,
        refreshBtn: false,
        searchMenuSpan: 6,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: '所属对象',
            prop: 'communityId',
            type: 'tree',
            dataType: 'string',
            clearable: false,
            dicUrl: 'api/v4ward/regulationSystem/treeChildrenPowerNode',
            props: { label: 'title', value: 'id' },
            search: true,
            rules: [
              {
                required: true,
                message: '请选择小区',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '标题',
            prop: 'title',
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            rules: [
              {
                required: true,
                message: '请输入标题',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '制度类型',
            prop: 'systemType',
            type: 'select',
            search: true,
            dicUrl: 'api/v4ward/systemType/tree',
            props: { label: 'name', value: 'id' },
          },
          {
            label: '内容',
            prop: 'content',
            component: 'AvueUeditor',
            params: {
              options: {
                //普通图片上传
                action: '/api/blade-resource/oss/endpoint/put-file',
                props: {
                  res: 'data',
                  url: 'link',
                },
              },
            },
            hide: true,
            span: 24,
            maxlength: 30,
            rules: [
              {
                required: true,
                message: '请输入内容',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '上传附件',
            prop: 'fileUrl',
            type: 'upload',
            span: 24,
            propsHttp: {
              res: 'data',
              url: 'link',
              name: 'originalName',
            },
            tip: '只能上传不超过40MB的文件或图片',
            action: '/api/blade-resource/oss/endpoint/put-file',
            dataType: 'string',
            hide: true,
          },
          {
            label: '创建时间',
            prop: 'createTime',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
          },
        ],
      },
      tempCommunityId: '',
      firstDisplayFlag: false,
      communityList: [],
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.regulationsystem_add, false),
        viewBtn: this.vaildData(this.permission.regulationsystem_view, false),
        delBtn: this.vaildData(this.permission.regulationsystem_delete, false),
        editBtn: this.vaildData(this.permission.regulationsystem_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    //加载列表
    getTreeChildrenPowerNode({}).then((res) => {
      this.communityList = res.data;
      if (this.communityList.length > 0) {
        this.query.communityId = this.communityList[0].id;
        this.tempCommunityId = this.communityList[0].id;
      }
      this.$nextTick(() => {
        this.avueCrudVisible = true;
      });
      //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
      this.firstDisplayFlag = true;
    });
  },
  methods: {
    getDialogData(values) {
      this.avueCrudVisible = false;
      this.firstDisplayFlag = true;
      console.log(values);
      if (values) {
        setTimeout(() => {
          this.avueCrudVisible = true;
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="所属对象"]');
            ent.value = this.communityList.length > 0 ? this.communityList[0].objectFullName : '';
            this.query.communityId = this.communityList.length > 0 ? this.communityList[0].id : '';
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }, 300);
      }
    },
    uploadPreview(file, column, done) {
      done(); //默认执行打开方法
      window.open(file.url);
    },
    rowSave(row, loading, done) {
      //校验附件格式拼接成字符串
      let a = '';
      if (row.fileUrl instanceof Array) {
        row.fileUrl.forEach((value, index, array) => {
          if (index == row.fileUrl.length - 1) {
            a += value.value;
          } else {
            a += value.value + ',';
          }
        });
        row.fileUrl = a;
      } else if (typeof row.fileUrl == 'string') {
      } else {
        row.fileUrl = a;
      }
      if (row.content.length > 20000) {
        this.$message.error('内容最大长度2万字');
        return done();
      }
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      //校验附件格式拼接成字符串
      let a = '';
      if (row.fileUrl instanceof Array) {
        row.fileUrl.forEach((value, index, array) => {
          if (index == row.fileUrl.length - 1) {
            a += value.value;
          } else {
            a += value.value + ',';
          }
        });
        row.fileUrl = a;
      } else if (typeof row.fileUrl == 'string') {
      } else {
        row.fileUrl = a;
      }
      if (row.content.length > 20000) {
        this.$message.error('内容最大长度2万字');
        return done();
      }
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    debounce(fn, wait) {
      var timeout = null;
      return function () {
        if (timeout !== null) clearTimeout(timeout);
        timeout = setTimeout(fn, wait);
      };
    },
    beforeOpen(done, type) {
      // if (['edit', 'add'].includes(type)) {
      //   setTimeout(() => {
      //     let el = document.querySelector(
      //       'div[id*="el-collapse-content"] > div > div > div:nth-child(4) > div > div > div > div.quill-editor > div.ql-container.ql-snow > div.ql-editor'
      //     );
      //     el.addEventListener('keyup', () => {
      //       console.log(el.innerText.length);
      //       if (el.innerText.length > 5000) {
      //         this.$message.error('内容最大长度5000字');
      //         el.innerText = el.innerText.substr(0, 5000);
      //       }
      //     });
      //     el.addEventListener('paste', (e) => {
      //       console.log(e);
      //       console.log(el.innerText.length);
      //       let pasteContent = (e.clipboardData || window.clipboardData).getData('text');
      //       console.log(pasteContent);
      //       if (el.innerText.length > 5000) {
      //         this.$message.error('内容最大长度5000字');
      //         el.innerText = el.innerText.substr(0, 5000);
      //       }
      //     });
      //   });
      // }
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      //开启默认搜索第一个小区
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    openSystemTypeDialog() {
      this.$refs.openSystemType.openSystemTypeDialog();
    },
    uploadBefore(file, done, loading) {
      const isLt40MB = file.size / 1024 < 40960;
      if (!isLt40MB) {
        this.$message.error('上传文件大小不能超过40MB!');
        loading();
        return;
      }
      if (isLt40MB) {
        done();
      }
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
      if (this.query.communityId == undefined || this.query.communityId == '') {
        this.query.communityId = this.tempCommunityId;
      }
      if (this.query.communityId) {
        getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
          ({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
            if (this.firstDisplayFlag) {
              let ent = document.querySelector('input[placeholder="所属对象"]');
              ent.value = this.communityList.length > 0 ? this.communityList[0].title : '';
              this.query.communityId =
                this.communityList.length > 0 ? this.communityList[0].id : '';
              //关闭默然显示，重刷页面时才开启默认显示
              this.firstDisplayFlag = false;
            }
          }
        );
      } else {
        this.loading = false;
      }
    },
  },
};
</script>

<style></style>
